var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLg = function SvgLg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.82481,
    height: 235.85306,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-71.756477,-167.06864)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2492)",
    id: "g2490",
    transform: "matrix(7.0593551,0,0,-7.0593551,-1219.9502,2145.5235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2496",
    style: {
      fill: "#c4084f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 199.679,246.85 c 9.226,0 16.705,7.491 16.705,16.703 0,9.229 -7.479,16.707 -16.705,16.707 -9.225,0 -16.701,-7.478 -16.701,-16.707 0,-9.212 7.476,-16.703 16.701,-16.703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2498",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 199.006,270.894 0,-14.661 4.652,0 0,1.317 -3.307,0 0,13.344 -1.345,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2500",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 194.342,266.886 c 1.103,0 2.011,0.896 2.011,2.002 0,1.112 -0.908,2.01 -2.011,2.01 -1.103,0 -2.005,-0.898 -2.005,-2.01 0,-1.106 0.902,-2.002 2.005,-2.002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2502",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 200.351,277.526 c -0.183,0.005 -0.5,0.005 -0.672,0.005 -7.711,0 -13.984,-6.26 -13.984,-13.975 0,-3.731 1.458,-7.246 4.091,-9.883 2.646,-2.643 6.149,-4.112 9.893,-4.112 3.736,0 7.244,1.469 9.888,4.112 2.633,2.637 4.083,6.152 4.083,9.883 l 0,0.639 -9.979,0 0,-1.298 8.655,0 c 0,-0.026 -0.006,-0.169 -0.006,-0.198 -0.426,-6.601 -5.948,-11.811 -12.641,-11.811 -3.38,0 -6.576,1.312 -8.965,3.699 -2.392,2.392 -3.717,5.583 -3.717,8.97 0,3.384 1.325,6.569 3.717,8.96 2.389,2.397 5.585,3.717 8.965,3.717 0.15,0 0.506,-0.008 0.672,-0.011 l 0,1.303"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lg.d2227c7f360589e1c52e494e06401ed5.svg";